import { z } from "zod";

import { CellType } from "./enums.js";

export enum ESDocType {
  HEX = "hex",
  APP = "app",
}

// Builds a schema accepting exactly an enum's values.
export const runtypeFromEnum = <EnumType>(
  theEnum: Record<string, EnumType>,
): z.ZodType<EnumType> => {
  const values = Object.values<unknown>(theEnum);
  const isEnumValue = (input: unknown): input is EnumType =>
    values.includes(input);
  const errorMessage = (input: unknown): string =>
    `Failed constraint check. Expected one of ${JSON.stringify(
      values,
    )}, but received ${JSON.stringify(input)}`;
  // `z.custom` is the zod equivalent of `Unknown.withConstraint<T>`: `.refine`
  // validates but cannot narrow the inferred type.
  return z.custom<EnumType>(isEnumValue, (input) => ({
    message: errorMessage(input),
  }));
};

export const ESDocTypeRuntype = runtypeFromEnum(ESDocType);
export const CellTypeRuntype = runtypeFromEnum(CellType);
